import { apiClient } from '../../utils';

export const composeTile = ({
  slideId,
  file,
  siteId,
  sliderId,
  caption,
  url,
}) =>
  apiClient.post('/merchant/slider/replaceItem', {
    data: {
      ...(file && file instanceof File ? { ma: file } : {}),
      ...(siteId ? { site: siteId } : {}),
      ...(sliderId ? { slider: sliderId } : {}),
      ...(slideId ? { replaceItem: slideId } : {}),
      ...(caption ? { caption } : {}),
      ...(url ? { url } : {}),
    },
    ...(file && file instanceof File ? { type: 'formData' } : {}),
  });
